import React from "react";
import DtsReactTable from "../../reuseableComponents/dtsReactTable/DtsReactTable";
import { convertTimeStampToDate } from "../../../utilities/commonFunctions/timeConversionFunctions";

const IpsViolationsTable = ({ data, handleShow, setItem, handleShowAG }) => {
  let columns = [
    {
      Header: "Violation Type",
      accessor: "violationName",
      width: 175
    },
    {
      Header: "Analyte",
      id: "analyte",
      width: 125,
      accessor: "analyteLabel",
      Cell: ({ row }) => {
        return row.original.isGrpAnalyte ? (
          <span
            className='hyperlink'
            onClick={() => {
              handleShowAG("Analyte");
              setItem(row.original);
            }}
            style={{ textDecoration: "underline" }}
          >
            {row.original.analyteLabel}
          </span>
        ) : (
          <span>{row.original.analyteLabel}</span>
        );
      }
    },
    {
      Header: "Points",
      accessor: "ipsPoints",
      width: 60
    },
    {
      Header: "Section",
      accessor: "reportName",
      width: 175
    },
    {
      Header: "Rule Name",
      accessor: "ruleName",
      width: 65
    },
    {
      Header: "Return to Compliance Method",
      accessor: (d) => {
        if (d.returnToComplianceMethod === "X") {
          return "Enforcement Action SOX";
        } else if (d.returnToComplianceMethod === "T") {
          return "Operational Year";
        } else {
          return "";
        }
      },
      width: 150
    },
    {
      Header: "Last Updated",
      accessor: (row) => {
        return row.lastUpdateDate ? convertTimeStampToDate(row.lastUpdateDate) + " by " + row.lastUpdateUser : "";
      }
    },
    {
      Header: "",
      accessor: "edit",
      width: 75,
      Cell: (row) => (
        <div className='text-center'>
          <span
            className='m-2 hyperlink'
            onClick={() => {
              handleShow("Edit");
              setItem(row.row.original);
            }}
          >
            Edit
          </span>
          <br />
          <span
            className='m-2 hyperlink'
            onClick={() => {
              handleShow("Delete");
              setItem(row.row.original);
            }}
          >
            Delete
          </span>
        </div>
      )
    }
  ];

  return (
    <>
      <DtsReactTable
        data={data}
        columns={columns}
        headerColor='ddw'
        rowOnClick={true}
        rowClickHandler={setItem}
        showGlobalFilter
      />
    </>
  );
};

export default IpsViolationsTable;
